import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { setSelectedTemplate } from "../../../actions/resumeBuilder";

const templates = [
  {
    id: 1,
    name: "Classic",
    description:
      "A timeless layout with clear sections for easy, professional reading.",
    thumbnail:
      "https://jobseekerspage.com/backend/data/assets/1751268916-olivia-wilson---30-jun-2025-13-02-51.jpg",
  },
  {
    id: 2,
    name: "Modern",
    description:
      "Clean, fresh design with smart spacing and a modern, stylish feel.",
    thumbnail:
      "https://jobseekerspage.com/backend/data/assets/1751267495-abdurrahman-saif---30-jun-2025-12-33-39-large-.jpg",
  },
  {
    id: 3,
    name: "Professional",
    description:
      "Polished layout emphasizing structure, clarity, and your key achievements.",
    thumbnail:
      "https://jobseekerspage.com/backend/data/assets/1751266486-abdurrahman-saif---1751264253-sas-page-0001-2-.jpg",
  },
  // {
  //   id: 5,
  //   name: "LoraineHudson",
  //   description:
  //     "Pixel-perfect, modern, and beautiful layout inspired by Loraine Hudson's professional resume.",
  //   thumbnail:
  //     "https://images.ctfassets.net/pdf29us7flmy/4b1QvQ9kQwQwQwQwQwQwQw/1234567890abcdef/loraine-hudson.jpg", // Use the same image as profile for now
  // },
  // {
  //   id: 4,
  //   name: "Elegant",
  //   description:
  //     "A sophisticated design with a distinct two-column layout and refined typography.",
  //   thumbnail:
  //     "https://via.placeholder.com/300x400.png?text=Elegant+Template", // Placeholder, replace with actual thumbnail
  // },
];

const ChooseResumeTemplates = () => {
  const dispatch = useDispatch();
  const selectedTemplate = useSelector((state) => state.resumeBuilder.selectedTemplate);

  console.log('selectedTemplate', selectedTemplate);

  const handleSelect = (template) => {
    dispatch(setSelectedTemplate(template));
  };

  useEffect(() => {
    dispatch(setSelectedTemplate(templates[1]));
  }, [dispatch]);

  return (
    <div className="pb-5 pt-4" style={{ minHeight: 500 }}>
      <h4 className="text-center mb-2 fw-bold" style={{ letterSpacing: 1 }}>
        Choose Your Resume Template
      </h4>
      <p className="text-center text-muted mb-4">
        Select a template that best fits your style and profession.
      </p>
      <Row className="justify-content-center g-4">
        {templates.map((template) => (
          <Col
            key={template.id}
            xs={12}
            sm={6}
            md={4}
            lg={4}
            className="d-flex justify-content-center"
          >
            <Card
              onClick={() => handleSelect(template)}
              className={`template-card border-0 shadow-sm position-relative ${
                selectedTemplate && selectedTemplate.id === template.id
                  ? "border-primary shadow-lg"
                  : ""
              }`}
              style={{
                width: 360, // Increased width from 300 to 360
                cursor: "pointer",
                background:
                  selectedTemplate && selectedTemplate.id === template.id ? "#eaf4ff" : "#fff",
                transition: "box-shadow 0.2s, background 0.2s",
                borderRadius: 16,
                border:
                  selectedTemplate && selectedTemplate.id === template.id
                    ? "2px solid #0d6efd"
                    : "1px solid #e3e6ea",
              }}
            >
              {selectedTemplate && selectedTemplate.id === template.id && (
                <div
                  className="position-absolute d-flex align-items-center justify-content-center"
                  style={{
                    top: 10,
                    right: 10,
                    zIndex: 5,
                    background: "#fff",
                    borderRadius: "50%",
                    width: 26,
                    height: 26,
                    border: "1.5px solid #0d6efd",
                    boxShadow: "0 1px 4px #0d6efd22",
                  }}
                >
                  <i
                    className="mdi mdi-check"
                    style={{
                      color: "#0d6efd",
                      fontSize: 16,
                      lineHeight: 1,
                    }}
                  />
                </div>
              )}
              <CardBody className="d-flex flex-column align-items-center p-3">
                <div
                  style={{
                    width: "100%",
                    height: 260,
                    background: "#f4f6fa",
                    borderRadius: 10,
                    overflow: "hidden",
                    marginBottom: 20,
                    border:
                      selectedTemplate && selectedTemplate.id === template.id
                        ? "2px solid #0d6efd"
                        : "1px solid #dee2e6",
                    boxShadow:
                      selectedTemplate && selectedTemplate.id === template.id
                        ? "0 0 0 2px #0d6efd22"
                        : "0 1px 4px rgba(0,0,0,0.04)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={template.thumbnail}
                    alt={template.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "top",
                      borderRadius: 8,
                      transition: "transform 0.2s",
                      transform:
                        selectedTemplate && selectedTemplate.id === template.id
                          ? "scale(1.03)"
                          : "scale(1)",
                      filter:
                        selectedTemplate && selectedTemplate.id === template.id
                          ? "none"
                          : "grayscale(10%)",
                    }}
                  />
                </div>
                <div
                  className={`fw-bold mb-1 text-center ${
                    selectedTemplate && selectedTemplate.id === template.id
                      ? "text-primary"
                      : "text-dark"
                  }`}
                  style={{ fontSize: 19, letterSpacing: 0.5 }}
                >
                  {template.name}
                </div>
                <div
                  className="text-muted mb-3 text-center"
                  style={{ fontSize: 15, minHeight: 40 }}
                >
                  {template.description}
                </div>
                <Button
                  color={
                    selectedTemplate && selectedTemplate.id === template.id
                      ? "primary"
                      : "outline-primary"
                  }
                  size="sm"
                  block="true"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelect(template);
                  }}
                  className="w-100 fw-semibold"
                  style={{
                    borderRadius: 8,
                    boxShadow:
                      selectedTemplate && selectedTemplate.id === template.id
                        ? "0 2px 8px #0d6efd22"
                        : "none",
                  }}
                >
                  {selectedTemplate && selectedTemplate.id === template.id ? (
                    <>
                      <i className="mdi mdi-check me-1" />
                      Selected
                    </>
                  ) : (
                    <>
                      Select Template
                    </>
                  )}
                </Button>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ChooseResumeTemplates;
